module.exports = __webpack_public_path__ + "img/icon(4).c3930c70.png";